import { HoneycombToolbarSlotProps } from '../types/toolbar.js';

/**
 * Slot for configuring the toolbar within a Honeycomb.
 * @public
 */
export const Toolbar = (props: HoneycombToolbarSlotProps) => null;

Toolbar.displayName = 'HoneycombToolbar';
